module.exports = __webpack_public_path__ + "static/media/market.03940fac.svg";